import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGoogleAnalytics, trackPageView } from '../services/analytics';

export default function GoogleAnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    initGoogleAnalytics();
    trackPageView(`${location.pathname}${location.search}${location.hash}`);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
